import { usePathname } from 'next/navigation';
import { type FC, type ReactNode, useCallback, useEffect } from 'react';
import { useComponentVisible } from '@/hooks/visibility';
import { IconComponent } from '../IconComponent';
import { ImageComponent } from '../Image';
import { isIconObject } from './helpers';
import { ScDashboardPanel } from './styled';

interface DeskDashboardPanel {
  icon?:
    | {
        width: number;
        height: number;
        src: string;
      }
    | ReactNode;
  content?: ReactNode;
  labelText?: string;
  popupContent: ReactNode | ((closePopup: () => void) => ReactNode);
}

export const DeskDashboardPanel: FC<DeskDashboardPanel> = ({
  icon,
  content,
  labelText,
  popupContent,
}) => {
  const { ref, openerRef, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);

  const pathname = usePathname();

  const handleClick = useCallback(() => {
    setIsComponentVisible((prev) => !prev);
  }, [setIsComponentVisible]);

  useEffect(() => {
    setIsComponentVisible(false);
  }, [pathname, setIsComponentVisible]);

  return (
    <ScDashboardPanel
      isOpen={isComponentVisible}
      onClick={handleClick}
      ref={openerRef}
    >
      {content ? (
        content
      ) : (
        <div className="loyalty-panel">
          <b className="level">{labelText}</b>
          {isIconObject(icon) ? (
            <ImageComponent
              alt="logo"
              height={icon?.height}
              objectFit="contain"
              src={icon?.src || ''}
              width={icon?.width}
            />
          ) : (
            icon
          )}
        </div>
      )}
      <IconComponent name="whiteArrowRight" size="18px" />
      {isComponentVisible && (
        <div
          className="popup"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          ref={ref}
          role="presentation"
        >
          {typeof popupContent === 'function'
            ? popupContent(() => setIsComponentVisible(false))
            : popupContent}
        </div>
      )}
    </ScDashboardPanel>
  );
};
